import { Button, Grid } from '@mui/material';
import React from 'react';
import CAppDataGrid from '../../../../../app/components/CAppDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';
import { DataGrid, frFR, enUS } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import AppFormatAmount from '../../../../../app/features/format/AppFormatAmount';

const CTestUiDataGrids = () => {
	const { i18n } = useTranslation();
	const rows = [
		{
			id: 1,
			name: 'Ligne 1',
			date: moment('2019-01-01').toDate(),
			amount: 12000,
		},
		{
			id: 2,
			name: 'Ligne 2',
			date: moment('2020-01-01').toDate(),
			amount: 120,
		},
		{
			id: 3,
			name: 'Ligne 3',
			date: moment('2021-01-01').toDate(),
			amount: -5000,
		},
		{
			id: 4,
			name: 'Ligne 4',
			date: moment('2019-01-01').toDate(),
			amount: -120000,
		},
	];

	const columns: GridColDef[] = [
		{
			field: 'name',
			headerName: 'Libellé',
			minWidth: 120,
			flex: 1,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'date',
			headerName: 'Date',
			minWidth: 120,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params: GridRenderCellParams) => moment(params.value).format('DD/MM/YYYY'),
		},
		{
			field: 'amount',
			headerName: 'Montant',
			minWidth: 120,
			align: 'right',
			headerAlign: 'right',
			renderCell: (params: GridRenderCellParams) => (
				<AppFormatAmount value={params.value} addSpace currency="USD" />
			),
		},
		{
			field: 'id',
			headerName: 'Actions',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: () => (
				<Button variant="contained" size="small" color="secondary" onClick={() => null}>
					Action
				</Button>
			),
		},
	];
	return (
		<>
			<CAppSubTitle title="Density - Standard" />
			<Grid container spacing={3}>
				<Grid item sm={6}>
					<CAppSubTitle title="DataGrid" />
					<DataGrid
						getRowClassName={(params) => `row-status--${params.row.fundIsRealized}`}
						rows={rows}
						columns={columns}
						autoHeight
						localeText={
							i18n.language === 'fr'
								? frFR.components.MuiDataGrid.defaultProps.localeText
								: enUS.components.MuiDataGrid.defaultProps.localeText
						}
						checkboxSelection
						disableSelectionOnClick
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Default" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						autoHeight
						checkboxSelection
						disableSelectionOnClick
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Primary" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						color="primary"
						autoHeight
						checkboxSelection
						disableSelectionOnClick
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Secondary" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						color="secondary"
						autoHeight
						checkboxSelection
						disableSelectionOnClick
					/>
				</Grid>
			</Grid>
			<CAppSubTitle title="Density - Compact" />
			<Grid container spacing={3}>
				<Grid item sm={6}>
					<CAppSubTitle title="DataGrid" />
					<DataGrid
						getRowClassName={(params) => `row-status--${params.row.fundIsRealized}`}
						rows={rows}
						columns={columns}
						autoHeight
						localeText={
							i18n.language === 'fr'
								? frFR.components.MuiDataGrid.defaultProps.localeText
								: enUS.components.MuiDataGrid.defaultProps.localeText
						}
						checkboxSelection
						disableSelectionOnClick
						density="compact"
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Default" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						autoHeight
						checkboxSelection
						disableSelectionOnClick
						density="compact"
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Primary" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						color="primary"
						autoHeight
						checkboxSelection
						disableSelectionOnClick
						density="compact"
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Secondary" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						color="secondary"
						autoHeight
						checkboxSelection
						disableSelectionOnClick
						density="compact"
					/>
				</Grid>
			</Grid>
			<CAppSubTitle title="Density - Comfortable" />
			<Grid container spacing={3}>
				<Grid item sm={6}>
					<CAppSubTitle title="DataGrid" />
					<DataGrid
						getRowClassName={(params) => `row-status--${params.row.fundIsRealized}`}
						rows={rows}
						columns={columns}
						autoHeight
						localeText={
							i18n.language === 'fr'
								? frFR.components.MuiDataGrid.defaultProps.localeText
								: enUS.components.MuiDataGrid.defaultProps.localeText
						}
						checkboxSelection
						disableSelectionOnClick
						density="comfortable"
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Default" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						autoHeight
						checkboxSelection
						disableSelectionOnClick
						density="comfortable"
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Primary" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						color="primary"
						autoHeight
						checkboxSelection
						disableSelectionOnClick
						density="comfortable"
					/>
				</Grid>
				<Grid item sm={6}>
					<CAppSubTitle title="CAppDataGrid" subtitle="Secondary" />
					<CAppDataGrid
						getRowClassName={(params) => `row-status--${params.row.disabled}`}
						rows={rows}
						columns={columns}
						color="secondary"
						autoHeight
						checkboxSelection
						disableSelectionOnClick
						density="comfortable"
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiDataGrids;
